module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAGCAYAAAD37n+BAAAApklEQVQYlW3OMS4GYRSF4ecbdmA9kq+1AYmoSP5gA9qZo9IoSETBCkSISESjmNICNKxBrxCfZib5iVudm/Pmvbe01o6wjosk1/6Zvu/3sImH0lrrsIUFzpLc/oF3p/4kydNKKaXVWl/RYVFr/RjH8W2Cd7A9iR6hDMMwm1axjw0cYw0HuExyM1/s5pDkC1e4wykOcY5fL3bLS5JP3OMdL3hO8r3M/AAAQzdmImeUVQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/attend_select_down.png
// module id = Liaw
// module chunks = 0